import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { ADMIN_NAVROUTES, FREE_NAVROUTES, USER_NAVROUTES } from "./NavRoutes";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";

import UserLayout from "../Layout/UserLayout";
import Login from "../Mycomponent/pages/login/login";
import Home from "../Mycomponent/pages";
import RankTracking from "../Mycomponent/pages/rankTracking";
import Register from "../Mycomponent/pages/login/register";
import PlLogin from "../Mycomponent/pages/login/plLogin";
import Upgrade from "../Mycomponent/pages/upgrade";
import Forgot from "../Mycomponent/pages/login/forgot";
import NoPage from "../Mycomponent/pages/login/noPage";
import Profile from "../Mycomponent/pages/profile";
import GoogleData from "../Mycomponent/pages/google-data/google-data";
import {
  guest_local_rank,
  inviteemail,
  admin,
  adminkeyword,
  backlinks,
  codes,
  dashboard,
  feedback,
  forgot,
  forgotPath,
  backlink_smtp,
  keyword_overview,
  keyword_variations,
  keyword_ideas,
  login,
  mail,
  nopage,
  overview,
  plans,
  pllogin,
  account,
  rank,
  register,
  register_InvitePath,
  siteaudit,
  upgrade,
  users,
  seokeyword,
  aiprojects,
  affiliateReward,
  register_Affiliate,
  ViewAllListBackLink,
  ViewAllList,
  backlinkChecker,
  seoTool,
  siteOverViewChecker,
  rankChecker,
  freeTool,
  freeTool_TableRankTracker,
  freeTool_TablePageVital,
  freeTool_TablebackLink,
  ai_CaptionGen,
  affiliateList,
  digital_agency,
  single_agency,
  review,
  google_data,
  backlink_gap,
  contact_agency,
  project,
  guest_rank,
  Crawled_Page_Editor,
  ai_writer,
  ai_writer_plan,
  site_prefix,
  sites,
  refreshSiteAudit,
  refreshKeyword,
  refreshSiteOverview,
  refreshBacklink,
  ai_writer_tool,
  aiRank,
  guest_ai_rank,
} from "./constant";
import Admin from "../admin/admin";
import User from "../admin/pages/user";
import Keyword from "../admin/pages/keyword";
import Plans from "../admin/pages/plans";
import Codes from "../admin/pages/codes";
import Siteaudit from "../Mycomponent/pages/siteaudit";
import Dashboard from "../admin/pages/dashboard";
import { useSelector } from "react-redux";
import PlAdd from "../Mycomponent/pages/login/plAdd";
import Mail from "../admin/pages/mail";
import SiteOverview from "../Mycomponent/pages/site-overview/SiteOverview";
import FeedBack from "../admin/pages/feedback";
import PlUpgrade from "../Mycomponent/pages/login/plUpgrade";
import InviteEmail from "../admin/pages/invitemail";
import SeoImpact from "../Tools/SeoImpact/SeoImpact";
import KeywordChecker from "../Mycomponent/pages/Tools/rank-checker";
import SiteOverView from "../Mycomponent/pages/Tools/site-overview";

import BackLinks from "../Mycomponent/pages/backlinks/backLinks";
import BacklinkSmtp from "../Mycomponent/pages/backlinks/backlink-smtp";
import { ViewList } from "../Mycomponent/pages/keyWordSubFiles/ViewList";
import ViewListBackLinks from "../Mycomponent/pages/backlinks/ViewListBackLinks";
import BacklinkChecker from "../Mycomponent/pages/Tools/backlink-checker";

import ToolUsage from "../admin/pages/ToolsUsage/toolUsage";
import RankTrackerTooltable from "../admin/pages/ToolsUsage/toolTable/RankTrackerTooltable";
import PageVitalToolTable from "../admin/pages/ToolsUsage/toolTable/PageVitalToolTable";
import BackLinkToolTable from "../admin/pages/ToolsUsage/toolTable/BackLinkToolTable";
import AiGenerateCaption from "../AiCaptionGenerator/AiGenerateCaption";
import seoMetaData from "../seo/seo-meta-data";
import SeoManager from "../seo/seo-manager";

// affiliate
import AffiliateLayout from "../Affiliate";
import ReferralUser from "../Mycomponent/pages/login/referral-user";
import { AffilateApprove } from "../admin/pages/AffilateApprove";
import AffiliateReward from "../admin/pages/affiliate";
import AffiliateWithdrawal from "../admin/pages/affiliate-withdrawal";
import {
  affiliate,
  LOGIN,
  SIGNUP,
  FORGOT,
  VERIFY,
  affiliate_notification,
  payment_earnings,
  promotional,
  PROFILE,
  performance_metrics,
  affiliate_withdrawal,
  update_agency,
} from "./constant";
import Affiliate from "../Affiliate/pages/home.page/home";
import { AffiliateLogin } from "../Affiliate/pages/login/Login";
import { Forget } from "../Affiliate/pages/login/Forget";
import { Signup } from "../Affiliate/pages/login/Signup";
import AffiliateNotification from "../Affiliate/pages/affiliate-notification";
import PaymentAndEarning from "../Affiliate/pages/payment-and-earning/payment-and-earning";
import AffilateDashboard from "../Affiliate/pages/dashboard/dashboard";
import Promotional from "../Affiliate/pages/promotional/promotional";
import { AffiliateProfile } from "../Affiliate/pages/Profile/Profile";
import Performance from "../Affiliate/pages/performance/performance";
import { Verify } from "../Affiliate/pages/login/Verify";
import { DigitalAgency } from "../admin/pages/digital-agencies/DigitalAgency";
import UpdateAgencies from "../admin/pages/digital-agencies/update-agencies";
import Contact from "../admin/pages/digital-agencies/contact";
import { SingleAgency } from "../admin/pages/SingleAgency";
import TermAndCondition from "../Affiliate/pages/term & condition/terms-and-conditions";
import AddOnPlan from "../admin/pages/Add-on-plans/addon";

// pdf viewer
import PdfViewer from "../Mycomponent/pages/pdf-viewer";
import Reviews from "../admin/pages/Reviewa";
import BacklinkGap from "../Mycomponent/pages/backlinks/backlink-gap";
import Projects from "../Mycomponent/pages/Project-Section/projects";
import CrawledPagesEditor from "../Mycomponent/pages/pdfEditors/CrawledPagesEditor";
import GuestLayout from "../Layout/GuestLayout";
import MapTracking from "../Mycomponent/pages/MapTracker/MapTracking";

import { ZustandStore } from "../store/zustand-store";
import AddProjectDialog from "../Mycomponent/pages/MapTracker/AddProjectDialog";
import AddLLMProjectDialog from "../Mycomponent/pages/LLM-Tracker/AddProjectDialog";
import UserQuesAns from "../admin/pages/UserQuesAns";
import UserProject from "../admin/pages/UserProject";
import SiteAuditData from "../admin/pages/RefreshData/SiteAuditData";
import KeywordData from "../admin/pages/RefreshData/KeywordData";
import SiteOverviewData from "../admin/pages/RefreshData/SiteOverviewData";
import BacklinkData from "../admin/pages/RefreshData/BacklinkData";
import { stringToBoolean } from "../helperJs/helper";

import AdsyLayout from "../Layout/AdsyLayout";
import Site from "../Adsy/pages/SearchForSites/Site";
import KeywordVariations from "../Mycomponent/pages/Keyword/KeywordVariations";
import KeywordIdeas from "../Mycomponent/pages/Keyword/KeywordIdeas";
import KeywordOverview from "../Mycomponent/pages/Keyword/KeywordOverview";
import GuestPost from "../admin/pages/GuestPost";

import AiTracking from "../Mycomponent/pages/AITracker/aiTracking";
import AddAIProjectDialog from "../Mycomponent/pages/AITracker/AddAIProjectDialog";
import { AITrackerStore } from "../store/AITrackerStore";
import LLMTracking from "../Mycomponent/pages/LLM-Tracker/LLMTracking";
import { LLMTrackerStore } from "../store/LLMTrackerStore";
import PricingTable from "../Mycomponent/pages/LLM-Tracker/pricingTable";
// AI Tools
const AITools = lazy(() => import("../Mycomponent/pages/AI-Writer/AITools"));
const AIToolWriter = lazy(() =>
  import("../Mycomponent/pages/AI-Writer/AIToolWriter")
);
// ai Writer
const PlanUpgradeDialog = lazy(() =>
  import("../Mycomponent/pages/MapTracker/PlanUpgradeDialog")
);
const AISaveContant = lazy(() =>
  import("../Mycomponent/pages/AI-Writer/AISaveContant")
);
const AIPlan = lazy(() =>
  import("../Mycomponent/share/components/AI-Writer/AI-Plan")
);

const RouterConfrigration = () => {
  const { ISPROJECT, customer_plan } = ZustandStore((state) => state);
  const { ISPROJECT: isProject } = AITrackerStore((state) => state);
  const { ISPROJECT: isProjectLLM } = LLMTrackerStore((state) => state);
  const isproject = useSelector((state) => state.isproject);
  const loginOut = useSelector((state) => state.loginout);
  const isplan = useSelector((state) => state.isplan);
  const map_tracker = stringToBoolean(customer_plan?.map_tracker) || false;
  const aio_tracker = Boolean(customer_plan?.ai_keyword) || false;
  const llm_tracker = Boolean(customer_plan?.llm_keyword) || false;
  return (
    <>
      <Routes>
        {FREE_NAVROUTES?.map(({ path, isAccessable, component: Component }) => {
          return (
            <Route
              key={path}
              path={path}
              element={
                <PublicRoute isAccessable={isAccessable}>
                  <Component />
                </PublicRoute>
              }
            />
          );
        })}

        <Route path={pllogin} element={<PlLogin />} />
        <Route path="/" element={<Navigate to="/dashboard" />} />
        {/* for unknown path  */}
        <Route
          path={nopage}
          element={
            <SeoManager data={seoMetaData?.page_not_found}>
              <NoPage />
            </SeoManager>
          }
        />
        <Route
          path={login}
          element={
            <SeoManager data={seoMetaData?.login}>
              <Login />
            </SeoManager>
          }
        />
        {/* register by mail url path */}
        <Route
          path={register_InvitePath}
          element={
            <SeoManager data={seoMetaData?.register}>
              <Register />
            </SeoManager>
          }
        />
        <Route
          path={register}
          element={
            <SeoManager data={seoMetaData?.register}>
              <Register />
            </SeoManager>
          }
        />
        {/* forgot by mail url path */}
        <Route
          path={forgotPath}
          element={
            <SeoManager data={seoMetaData?.forgot}>
              <Forgot />
            </SeoManager>
          }
        />
        <Route
          path={forgot}
          element={
            <SeoManager data={seoMetaData?.forgot}>
              <Forgot />
            </SeoManager>
          }
        />
        <Route
          path={"/"}
          element={
            <SeoManager>
              <UserLayout />
            </SeoManager>
          }
        >
          {/* main pages  */}

          <Route
            path={project}
            index
            element={
              !isplan ? (
                <PlUpgrade />
              ) : isproject ? (
                <SeoManager data={seoMetaData?.home}>
                  <Projects />
                </SeoManager>
              ) : !loginOut ? (
                <PlLogin />
              ) : (
                <PlAdd />
              )
            }
          />

          <Route
            path="/dashboard"
            element={
              !isplan ? (
                <PlUpgrade />
              ) : isproject ? (
                <SeoManager data={seoMetaData?.home}>
                  <Home />
                </SeoManager>
              ) : !loginOut ? (
                <PlLogin />
              ) : (
                <PlAdd />
              )
            }
          />

          <Route
            path={google_data}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : isproject ? (
                <SeoManager data={seoMetaData?.home}>
                  <GoogleData />
                </SeoManager>
              ) : !loginOut ? (
                <PlLogin />
              ) : (
                <PlAdd />
              )
            }
          />
          <Route
            path={"llm-tracker"}
            element={
              !llm_tracker ? (
                <PricingTable />
              ) : isProjectLLM ? (
                <SeoManager data={seoMetaData?.rank_tracking}>
                  <LLMTracking />
                </SeoManager>
              ) : !loginOut ? (
                <PlLogin />
              ) : (
                <AddLLMProjectDialog />
              )
            }
          />
          <Route
            path={"map-tracker"}
            element={
              !map_tracker ? (
                <Suspense fallback={null}>
                  <PlanUpgradeDialog />
                </Suspense>
              ) : ISPROJECT ? (
                <SeoManager data={seoMetaData?.rank_tracking}>
                  <MapTracking />
                </SeoManager>
              ) : !loginOut ? (
                <PlLogin />
              ) : (
                <AddProjectDialog />
              )
            }
          />

          <Route
            path={rank}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : isproject ? (
                <SeoManager data={seoMetaData?.rank_tracking}>
                  <RankTracking />
                </SeoManager>
              ) : !loginOut ? (
                <PlLogin />
              ) : (
                <PlAdd />
              )
            }
          />
          <Route
            path={aiRank}
            element={
              !aio_tracker ? (
                <PlUpgrade />
              ) : isProject ? (
                <SeoManager data={seoMetaData?.rank_tracking}>
                  <AiTracking />
                </SeoManager>
              ) : !loginOut ? (
                <PlLogin />
              ) : (
                <AddAIProjectDialog />
              )
            }
          />
          <Route
            path={ai_writer_plan}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : (
                <Suspense fallback={null}>
                  <AIPlan />
                </Suspense>
              )
            }
          />

          <Route
            path={ai_writer}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : (
                <Suspense fallback={null}>
                  <AITools />
                </Suspense>
              )
            }
          />

          <Route
            path={aiprojects}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : (
                <Suspense fallback={null}>
                  <AISaveContant />
                </Suspense>
              )
            }
          />

          <Route
            path={ai_writer_tool}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : (
                <SeoManager data={seoMetaData?.ai_writer_tool_prompt}>
                  <Suspense fallback={null}>
                    <AIToolWriter />
                  </Suspense>
                </SeoManager>
              )
            }
          />

          {USER_NAVROUTES?.map(
            ({
              path,
              isLoginRequire,
              isPlanRequire,
              isProjectRequire,
              component: Component,
            }) => {
              return (
                <Route
                  key={path}
                  path={path}
                  element={
                    <ProtectedRoute
                      isPlanRequire={isPlanRequire}
                      isLoginRequire={isLoginRequire}
                      isProjectRequire={isProjectRequire}
                    >
                      <Component />
                    </ProtectedRoute>
                  }
                />
              );
            }
          )}

          <Route
            path="/pdf-editor"
            element={
              !isplan ? (
                <PlUpgrade />
              ) : isproject ? (
                <PdfViewer />
              ) : !loginOut ? (
                <PlLogin />
              ) : (
                <PlAdd />
              )
            }
          />

          <Route
            path={Crawled_Page_Editor}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : isproject ? (
                <CrawledPagesEditor />
              ) : !loginOut ? (
                <PlLogin />
              ) : (
                <PlAdd />
              )
            }
          />

          <Route
            path={siteaudit}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : isproject ? (
                <SeoManager data={seoMetaData?.site_audit}>
                  <Siteaudit />
                </SeoManager>
              ) : !loginOut ? (
                <PlLogin />
              ) : (
                <PlAdd />
              )
            }
          />
          <Route
            path={overview}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : loginOut ? (
                <SeoManager data={seoMetaData?.site_overview}>
                  <SiteOverview />
                </SeoManager>
              ) : (
                <PlLogin />
              )
            }
          />
          <Route
            path={backlink_gap}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : (
                <SeoManager data={seoMetaData?.backlink}>
                  <BacklinkGap />
                </SeoManager>
              )
            }
          />
          <Route
            path={backlinks}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : (
                <SeoManager data={seoMetaData?.backlink}>
                  <BackLinks />
                </SeoManager>
              )
            }
          />

          <Route
            path={keyword_ideas}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : (
                <SeoManager data={seoMetaData?.keyword}>
                  <KeywordIdeas />
                </SeoManager>
              )
            }
          />
          <Route
            path={keyword_overview}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : (
                <SeoManager data={seoMetaData?.keyword}>
                  <KeywordOverview />
                </SeoManager>
              )
            }
          />
          <Route
            path={keyword_variations}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : (
                <SeoManager data={seoMetaData?.keyword}>
                  <KeywordVariations />
                </SeoManager>
              )
            }
          />

          <Route
            path={ViewAllList}
            element={!isplan ? <PlUpgrade /> : <ViewList />}
          />

          <Route
            path={ViewAllListBackLink}
            element={!isplan ? <PlUpgrade /> : <ViewListBackLinks />}
          />

          <Route
            path={backlink_smtp}
            element={
              !isplan ? (
                <PlUpgrade />
              ) : (
                <SeoManager data={seoMetaData?.backlink}>
                  <BacklinkSmtp />
                </SeoManager>
              )
            }
          />
          {/* header pages  */}
          <Route
            path={account}
            element={
              loginOut ? (
                <SeoManager data={seoMetaData?.account}>
                  <Profile />
                </SeoManager>
              ) : (
                <PlLogin />
              )
            }
          />

          <Route
            path={upgrade}
            element={
              loginOut ? (
                <SeoManager data={seoMetaData?.upgrade}>
                  <Upgrade />
                </SeoManager>
              ) : (
                <PlLogin />
              )
            }
          />
        </Route>

        {/* Guest link*/}
        <Route path={guest_rank} element={<GuestLayout />}>
          <Route
            index
            element={
              <SeoManager data={seoMetaData?.guest_rank_tracking}>
                <RankTracking />
              </SeoManager>
            }
          />
        </Route>

        <Route path={guest_local_rank} element={<GuestLayout />}>
          <Route
            index
            element={
              <SeoManager data={seoMetaData?.guest_rank_tracking}>
                <MapTracking />
              </SeoManager>
            }
          />
        </Route>

        <Route path={guest_ai_rank} element={<GuestLayout />}>
          <Route
            index
            element={
              <SeoManager data={seoMetaData?.guest_rank_tracking}>
                <AiTracking />
              </SeoManager>
            }
          />
        </Route>

        <Route path={"guest/llm-tracker"} element={<GuestLayout />}>
          <Route
            index
            element={
              <SeoManager data={seoMetaData?.guest_rank_tracking}>
                <LLMTracking />
              </SeoManager>
            }
          />
        </Route>

        {/* here the Admin Layout  */}
        <Route path={admin} element={<Admin />}>
          <Route index element={<Dashboard />} />
          <Route path={dashboard} element={<Dashboard />} />
          <Route path={users} element={<User />} />
          <Route path={adminkeyword} element={<Keyword />} />
          <Route path={plans} element={<Plans />} />
          <Route path={codes} element={<Codes />} />
          <Route path={mail} element={<Mail />} />
          <Route path={feedback} element={<FeedBack />} />
          <Route path={affiliateReward} element={<AffiliateReward />} />
          <Route path={inviteemail} element={<InviteEmail />} />
          {/*  Tools For admin */}
          <Route path={freeTool} element={<ToolUsage />} />
          <Route
            path={freeTool_TableRankTracker}
            element={<RankTrackerTooltable />}
          />
          <Route
            path={freeTool_TablePageVital}
            element={<PageVitalToolTable />}
          />
          <Route
            path={freeTool_TablebackLink}
            element={<BackLinkToolTable />}
          />
          <Route path={"product/sites"} element={<GuestPost />} />
          <Route path={affiliateList} element={<AffilateApprove />} />
          <Route
            path={affiliate_withdrawal}
            element={<AffiliateWithdrawal />}
          />
          {/* Digital Agency  */}
          <Route path={digital_agency} element={<DigitalAgency />} />
          <Route path={update_agency} element={<UpdateAgencies />} />
          <Route path={contact_agency} element={<Contact />} />
          <Route path={single_agency} element={<SingleAgency />} />
          <Route path={review} element={<Reviews />} />
          <Route path="addon-plans" element={<AddOnPlan />} />
          <Route path="user/question/answer" element={<UserQuesAns />} />
          <Route path="user/project" element={<UserProject />} />
          <Route path={refreshSiteAudit} element={<SiteAuditData />} />
          <Route path={refreshKeyword} element={<KeywordData />} />
          <Route path={refreshBacklink} element={<BacklinkData />} />
          <Route path={refreshSiteOverview} element={<SiteOverviewData />} />

          {ADMIN_NAVROUTES?.map(({ path, component: Component }) => {
            return <Route key={path} path={path} element={<Component />} />;
          })}
        </Route>

        {/* here the Affiliate Layout start */}
        {/* <Route
          path="affiliate/"
          element={
            <SeoManager data={seoMetaData?.affiliate}>
              <Affiliate />
            </SeoManager>
          }
        />
        <Route
          path={LOGIN}
          element={
            <SeoManager data={seoMetaData?.aff_login}>
              <AffiliateLogin />
            </SeoManager>
          }
        />
        <Route
          path={FORGOT}
          element={
            <SeoManager data={seoMetaData?.aff_forgot}>
              <Forget />
            </SeoManager>
          }
        />
        <Route
          path={SIGNUP}
          element={
            <SeoManager data={seoMetaData?.aff_signup}>
              <Signup />
            </SeoManager>
          }
        />
        <Route path={VERIFY} element={<Verify />} />
        <Route
          path={register_Affiliate}
          element={
            <SeoManager data={seoMetaData?.register}>
              <ReferralUser />
            </SeoManager>
          }
        />

        <Route
          path={register_Affiliate}
          element={
            <SeoManager data={seoMetaData?.register}>
              <ReferralUser />
            </SeoManager>
          }
        /> */}

        {/* <Route path={affiliate} element={<AffiliateLayout />}>
          <Route index path={dashboard} element={<AffilateDashboard />} />
          <Route
            path={affiliate_notification}
            element={<AffiliateNotification />}
          />
          <Route path={performance_metrics} element={<Performance />} />
          <Route path={payment_earnings} element={<PaymentAndEarning />} />
          <Route path={promotional} element={<Promotional />} />
          <Route path={PROFILE} element={<AffiliateProfile />} />
        </Route> */}
        <Route
          path={"terms-&-conditions"}
          element={
            <SeoManager data={seoMetaData?.term_and_condition}>
              <TermAndCondition />
            </SeoManager>
          }
        />

        {/* seo free tool route free checker */}
        <Route
          path={siteOverViewChecker}
          element={
            <SeoManager data={seoMetaData?.free_site_overview}>
              <SiteOverView />
            </SeoManager>
          }
        />
        <Route
          path={backlinkChecker}
          element={
            <SeoManager data={seoMetaData?.backlink_checker}>
              <BacklinkChecker />
            </SeoManager>
          }
        />
        <Route
          path={seoTool}
          element={
            <SeoManager data={seoMetaData?.seo_insight}>
              <SeoImpact />
            </SeoManager>
          }
        />
        <Route
          path={rankChecker}
          element={
            <SeoManager data={seoMetaData?.rank_checker}>
              <KeywordChecker />
            </SeoManager>
          }
        />

        <Route
          path={ai_CaptionGen}
          element={
            <SeoManager data={seoMetaData?.ai_caption}>
              <AiGenerateCaption />
            </SeoManager>
          }
        />

        {/* AdsyLayout */}
        <Route path={site_prefix} element={<AdsyLayout />}>
          <Route
            index
            path={sites}
            element={
              <SeoManager data={seoMetaData?.sites}>
                <Site name="Sites" />
              </SeoManager>
            }
          />
        </Route>
      </Routes>
    </>
  );
};

export default RouterConfrigration;
